import React from "react";
import ExternalRegisterHeader from "../components/ExternalRegisterHeader";
import ExternalRegisterFooter from "../components/ExternalRegisterFooter";

const ExternalRegisterLayout = ({ children }) => {
    return (
        <div className="flex min-h-screen bg-white">
            <div className="flex flex-col flex-1">

                <ExternalRegisterHeader />

                <main className="flex-1 bg-[#F7F9FC] mt-16">
                    {children}
                </main>

                <ExternalRegisterFooter />
            </div>
        </div>
    );
};

export default ExternalRegisterLayout;
